import React, { useCallback, useEffect, useRef } from 'react';

import SearchResultBox from './search_result_box';
import SearchEventBoxVertical2 from './search_event_box_vertical2';

const SearchResult = ({
  searchTitle,
  circles,
  events,
  loadNextList,
  isLoadingNextList,
  isLastPage,
  currentUser,
  barColor,
  hashedCompanyId = null,
}) => {
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  const handleScrollEvent = useCallback(() => {
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = $(window).scrollTop();
    if (
      scrolled > ancPosition / 2 &&
      // scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (isLastPage) {
      window.removeEventListener('scroll', handleScrollEvent);
    } else {
      window.addEventListener('scroll', handleScrollEvent);
    }

    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, [isLastPage, handleScrollEvent]);

  return (
    <React.Fragment>
      <div className="position-relative container">
        <h1
          style={{ fontSize: '18px', paddingLeft: '0px', marginBottom: '8px' }}
          className="left h2--extend -event"
        >
          {searchTitle}
        </h1>
      </div>
      <div className="container">
        <div className="row">
          {events.length > 0
            ? events.map(function (event) {
                return (
                  <SearchEventBoxVertical2
                    key={event.id}
                    eventItem={event}
                    currentUser={currentUser}
                    hashedCompanyId={hashedCompanyId}
                  />
                );
              })
            : circles.map(function (circle, index) {
                return (
                  <SearchResultBox
                    circle={circle}
                    key={`basic_${circle.id}_${index}`}
                    hashedCompanyId={hashedCompanyId}
                  />
                );
              })}
        </div>
        {isLoadingNextList ? (
          <div className="text-center pt-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          ''
        )}
        <div id="ancLastItem" ref={ancLastItemRef} />
      </div>
    </React.Fragment>
  );
};

export default SearchResult;
